export function createTimeoutSignal(milliseconds) {
  if (typeof AbortSignal !== "undefined" && typeof AbortSignal.timeout === "function") {
    return { signal: AbortSignal.timeout(milliseconds), clear() {} };
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(new DOMException("Request timed out", "TimeoutError")), milliseconds);
  return { signal: controller.signal, clear: () => clearTimeout(timer) };
}
